import React from 'react';
import { Tooltip, IconButton } from '@material-ui/core';
import { Email, LinkedIn, GitHub } from '@material-ui/icons';
import Resume from '../../settings/resume.json';

const profileIcons = { LinkedIn, GitHub };
const contacts = [
  { network: 'Email', username: Resume.basics.email, url: `mailto:${Resume.basics.email}`, Icon: Email },
  ...Resume.basics.profiles.map(profile => ({ ...profile, Icon: profileIcons[profile.network] })),
];

export const SocialIcons = () => (
  <nav className="contact-icons" aria-label="Contact links">
    {contacts.map(({ network, username, url, Icon }) => (
      <Tooltip key={network} title={`${network}: ${username}`} placement="left">
        <IconButton
          component="a"
          href={url}
          target={network === 'Email' ? undefined : '_blank'}
          rel={network === 'Email' ? undefined : 'noopener noreferrer'}
          aria-label={network}
          className="contact-icon"
        >
          <Icon aria-hidden="true" />
        </IconButton>
      </Tooltip>
    ))}
  </nav>
);

export const ContactLinks = () => (
  <ul className="contact-details" aria-label="Contact details">
    {contacts.map(({ network, username, url, Icon }) => (
      <li key={network}>
        <a href={url} target={network === 'Email' ? undefined : '_blank'} rel={network === 'Email' ? undefined : 'noopener noreferrer'}>
          <Icon aria-hidden="true" />
          <span><span className="contact-label">{network}</span><span>{username}</span></span>
        </a>
      </li>
    ))}
  </ul>
);
